import { render, staticRenderFns } from "./roleDataPower.vue?vue&type=template&id=6ae01145&scoped=true&"
import script from "./roleDataPower.vue?vue&type=script&lang=js&"
export * from "./roleDataPower.vue?vue&type=script&lang=js&"
import style1 from "./roleDataPower.vue?vue&type=style&index=1&id=6ae01145&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae01145",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\2000HuiTian\\huitianadmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ae01145')) {
      api.createRecord('6ae01145', component.options)
    } else {
      api.reload('6ae01145', component.options)
    }
    module.hot.accept("./roleDataPower.vue?vue&type=template&id=6ae01145&scoped=true&", function () {
      api.rerender('6ae01145', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/roleDataPower.vue"
export default component.exports